<nb-card class="dialog-card pre-inscricao-agendas">
  <nb-card-header>
    <span class="titulo">Horários de atendimento</span>
    <span class="subtitulo" *ngIf="campanhaNome">{{ campanhaNome }}</span>
  </nb-card-header>

  <nb-card-body>
    <p class="explica">
      Cada inscrito vai para o horário futuro mais cedo que ainda tem lugar; lotado um, os próximos
      vão para o seguinte. A família não escolhe o horário.
    </p>

    <!-- PRE-15: sem horário futuro com lugar, o link público recusa todo mundo. -->
    <div class="alerta-sem-lugar" role="alert" *ngIf="semLugar">
      <nb-icon pack="eva" icon="alert-triangle-outline"></nb-icon>
      <span>
        <strong>Nenhum horário futuro com lugar.</strong> Enquanto for assim, o link público recusa
        toda pré-inscrição. Adicione um horário ou aumente o limite de um que ainda não passou.
      </span>
    </div>

    <div class="carregando" *ngIf="carregando">
      <nb-spinner status="primary" size="medium"></nb-spinner>
      <span>Carregando horários…</span>
    </div>

    <table class="agendas-table" *ngIf="!carregando && agendas.length">
      <thead>
        <tr>
          <th>Data e hora</th>
          <th class="col-num">Limite</th>
          <th class="col-num">Agendados</th>
          <th class="col-num">Disponíveis</th>
          <th class="col-acoes">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let a of agendas" [class.passou]="jaPassou(a)">
          <td>
            {{ rotulo(a.dataHora) }}
            <span class="tag-passou" *ngIf="jaPassou(a)">já passou</span>
          </td>
          <td class="col-num">{{ a.limiteAtendidos ?? '—' }}</td>
          <td class="col-num">{{ a.agendados ?? 0 }}</td>
          <td class="col-num">{{ a.disponiveis ?? 0 }}</td>
          <td class="col-acoes">
            <div class="acao-btns acao-btns--inline" role="group">
              <button
                type="button"
                nbButton
                size="small"
                appearance="outline"
                status="basic"
                class="btn-acao"
                (click)="editar(a)"
                title="Editar horário"
                aria-label="Editar horário"
              >
                <nb-icon pack="eva" icon="edit-outline"></nb-icon>
              </button>
              <button
                type="button"
                nbButton
                size="small"
                appearance="outline"
                status="danger"
                class="btn-acao"
                [disabled]="!!a.agendados"
                (click)="excluir(a)"
                [title]="a.agendados ? 'Horário com inscrito não pode ser excluído' : 'Excluir horário'"
                aria-label="Excluir horário"
              >
                <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="vazio" *ngIf="!carregando && carregou && !agendas.length">Nenhum horário cadastrado ainda.</p>

    <form class="form-agenda" (ngSubmit)="salvar()">
      <span class="form-titulo">{{ editandoId ? 'Editar horário' : 'Novo horário' }}</span>

      <div class="linha">
        <div class="campo campo--data">
          <app-campo-data
            id="ag-data"
            rotulo="Data"
            [valor]="data"
            (valorChange)="data = $event"
          ></app-campo-data>
        </div>
        <div class="campo">
          <label class="field-label" for="ag-hora">Hora</label>
          <input nbInput fullWidth id="ag-hora" name="hora" type="time" [(ngModel)]="hora" />
        </div>
        <div class="campo">
          <label class="field-label" for="ag-limite">Limite de atendidos</label>
          <input nbInput fullWidth id="ag-limite" name="limiteAtendidos" type="number" min="1" [(ngModel)]="limiteAtendidos" />
        </div>
      </div>

      <!-- PRE-14: o inscrito aponta para o horário, então mudar a data remarca quem já está nele. -->
      <p class="aviso-remarca" *ngIf="remarcaInscritos">
        <nb-icon pack="eva" icon="info-outline"></nb-icon>
        <span>
          {{ agendadosEmEdicao }} {{ agendadosEmEdicao === 1 ? 'pessoa já está' : 'pessoas já estão' }} neste
          horário e {{ agendadosEmEdicao === 1 ? 'será remarcada' : 'serão remarcadas' }} para o novo, <strong>sem
          e-mail de aviso</strong>. Para avisar, use "Reenviar" na lista de pré-inscritos: a confirmação sai com o
          horário novo.
        </span>
      </p>

      <div class="form-acoes">
        <button nbButton size="small" status="basic" type="button" *ngIf="editandoId" (click)="cancelarEdicao()">
          Cancelar edição
        </button>
        <button nbButton size="small" status="primary" type="submit" [disabled]="salvando" [nbSpinner]="salvando">
          {{ editandoId ? 'Salvar horário' : 'Adicionar horário' }}
        </button>
      </div>
    </form>
  </nb-card-body>

  <nb-card-footer class="footer-actions">
    <button nbButton status="primary" size="medium" type="button" (click)="fechar()">Fechar</button>
  </nb-card-footer>
</nb-card>
